import { render } from "./IconSubMenu.vue?vue&type=template&id=406bb9eb"
import script from "./IconSubMenu.vue?vue&type=script&lang=js"
export * from "./IconSubMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__